/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Select_To_EditInputs */



/**
* | output |
* | --- |
* | "Select an artifact to edit" |
*
* @param {Artifact_Select_To_EditInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_select_to_edit = /** @type {((inputs?: Artifact_Select_To_EditInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Select_To_EditInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wähle ein Artefakt zum Bearbeiten aus")
	return /** @type {LocalizedString} */ ("Select an artifact to edit")
});